import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '.';
import { User } from '../_models';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  curentUser: User;
  constructor(
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.currentUser.subscribe(x => this.curentUser = x);
  }

  public roles(): Observable<any> {
    const array1 = [this.curentUser.role]
    return of(array1);
  }
}
